import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import InternalLink from '../../router/InternalLink'
import HrbTranslate from '../language/HrbTranslate'
import lang from '../language/services/Lang'

const SideNavLink = props => {

    const { elementId, selected, to, textKey, icon, children} = props
    const classNames = classnames('nav-link level columns mr-0', { 'selected': selected })

    const text = useSelector(state => lang.getValue(textKey, state.layout.lang))

    return (
        <InternalLink elementId={elementId} to={to} className={classNames}>
            <div className='level-item column is-1 is-offset-2 pl-0'>
                <div className='nav-icon'>
                    {children}
                    {!children &&
                        <img src={icon} alt={text} />
                    }
                </div>
            </div>
            <div className='level-item column is-9'>
                <HrbTranslate text={textKey} />
            </div>
        </InternalLink>)
}

SideNavLink.propTypes = {
    elementId: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    to: PropTypes.string.isRequired,
    textKey: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    children: PropTypes.node
}

export default SideNavLink